import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-16 lg:py-24 bg-neutral-50" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-14 items-center" }
const _hoisted_4 = { class: "order-1 lg:order-2" }
const _hoisted_5 = { class: "space-y-6 mb-10" }
const _hoisted_6 = { class: "flex-shrink-0 w-11 h-11 bg-primary-50 rounded-xl flex items-center justify-center" }
const _hoisted_7 = {
  class: "w-5 h-5 text-primary-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = { class: "text-base font-bold text-neutral-800 mb-1" }
const _hoisted_10 = { class: "text-sm text-neutral-500 leading-relaxed" }
const _hoisted_11 = { class: "flex items-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"relative order-2 lg:order-1\"><div class=\"relative rounded-2xl overflow-hidden shadow-2xl\"><img src=\"https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=650&amp;q=80\" alt=\"Real estate professionals\" class=\"w-full h-80 lg:h-[480px] object-cover\"><div class=\"absolute inset-0 bg-gradient-to-t from-black/30 to-transparent\"></div></div><div class=\"absolute -top-5 -left-5 bg-primary-500 text-white rounded-2xl px-6 py-5 shadow-xl\"><div class=\"text-4xl font-extrabold leading-none\">5</div><div class=\"text-xs font-medium mt-1 text-primary-100\">Years Experience</div></div><div class=\"absolute -bottom-5 -right-5 bg-white rounded-2xl p-4 shadow-xl border border-neutral-100 max-w-[180px]\"><div class=\"flex items-center gap-2 mb-1\"><div class=\"w-8 h-8 bg-accent-100 rounded-lg flex items-center justify-center\"><svg class=\"w-4 h-4 text-accent-500\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path d=\"M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z\"></path></svg></div><span class=\"text-xs font-bold text-neutral-800\">Top Platform</span></div><p class=\"text-xs text-neutral-500 leading-snug\">Rwanda&#39;s #1 Digital Real Estate Platform</p></div><div class=\"absolute -z-10 -bottom-10 -left-10 w-56 h-56 bg-primary-100 rounded-full blur-3xl opacity-60\"></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-primary-500 text-sm font-semibold uppercase tracking-widest mb-3" }, "Why Choose Us", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-neutral-800 mb-4 leading-tight" }, [
            _createTextVNode(" Rwanda's Leading "),
            _createElementVNode("br", { class: "hidden md:block" }),
            _createTextVNode(" Digital Property Platform ")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-neutral-500 text-base mb-10 max-w-md leading-relaxed" }, " Since 2021, we have helped thousands of buyers, renters, and investors find the right property across Rwanda. Our platform connects you with verified agents, accurate listings, and expert guidance — all in one place. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
              return (_openBlock(), _createElementBlock("div", {
                key: feature.title,
                class: "flex items-start gap-4"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: feature.icon
                    }, null, 8, _hoisted_8)
                  ]))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(feature.title), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(feature.description), 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[1] || (_cache[1] = _createElementVNode("a", {
              href: "tel:+250789326245",
              class: "inline-flex items-center gap-3 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3.5 rounded-xl font-semibold text-sm transition-colors shadow-sm"
            }, [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                })
              ]),
              _createTextVNode(" +250 789 326 245 ")
            ], -1)),
            _createVNode(_component_router_link, {
              to: "/about",
              class: "inline-flex items-center gap-2 text-sm font-semibold text-neutral-700 hover:text-primary-500 transition-colors"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Learn More ", -1),
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M17 8l4 4m0 0l-4 4m4-4H3"
                  })
                ], -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}